export const APOD_SIGN_IN_URL = "https://app.anywherepod.com/";
export const APOD_SIGN_UP_URL = "https://app.anywherepod.com/register?intent=InnerCirclePrints";

export const isApodFlag = (value) =>
  value === 1 || value === "1" || value === true;

export const isApodManagedProduct = (product) =>
  Boolean(
    product &&
      (isApodFlag(product.is_apod) ||
        product.apod_product_id ||
        product.source === "apod"),
  );

export const hasApodOrderId = (value) => {
  if (value == null) return false;
  const normalized = String(value).trim().toLowerCase();
  return normalized !== "" && normalized !== "null" && normalized !== "0";
};

export const isApodManagedOrder = (order) =>
  Boolean(
    order &&
      (hasApodOrderId(order.apod_order_id) ||
        (Array.isArray(order.orderDetails) &&
          order.orderDetails.some((item) =>
            hasApodOrderId(item?.apod_order_id),
          ))),
  );

export const isApodManagedOrderItem = (item, order) =>
  hasApodOrderId(item?.apod_order_id) || isApodManagedOrder(order);

export const extractUserUuid = (...sources) => {
  for (const source of sources) {
    if (!source || typeof source !== "object") continue;
    const value =
      source.uuid ??
      source.api_key ??
      source.apiKey ??
      source.x_api_key ??
      source["x-api-key"];
    if (value) return String(value);
  }
  return "";
};

export const getAuthUserExtras = (
  userData = {},
  dataFilter = {},
  previous = {},
) => ({
  parent_id: userData.parent_id ?? previous.parent_id ?? null,
  print_provider_id:
    userData.print_provider_id ??
    userData.print_provider?.id ??
    previous.print_provider_id ??
    null,
  priority_seller:
    userData.priority_seller ??
    dataFilter.priority_seller ??
    previous.priority_seller,
  uuid: extractUserUuid(userData, dataFilter) || previous.uuid || null,
});
